function coerceFiniteNumber(value: unknown, field: string): number {
  const numeric = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(numeric)) {
    throw new Error(`${field} must be a finite number.`)
  }
  return numeric
}

export function parseLocationCoordinates(input: {
  latitude: unknown
  longitude: unknown
}): { latitude: number; longitude: number } {
  const latitude = coerceFiniteNumber(input.latitude, 'Latitude')
  const longitude = coerceFiniteNumber(input.longitude, 'Longitude')

  if (latitude < -90 || latitude > 90) {
    throw new Error('Latitude must be between -90 and 90.')
  }
  if (longitude < -180 || longitude > 180) {
    throw new Error('Longitude must be between -180 and 180.')
  }

  return {
    latitude,
    longitude,
  }
}

export function calculateDistanceMeters(
  origin: { latitude: number; longitude: number },
  destination: { latitude: number; longitude: number },
): number {
  const earthRadiusMeters = 6371000
  const toRadians = (value: number) => (value * Math.PI) / 180
  const deltaLatitude = toRadians(destination.latitude - origin.latitude)
  const deltaLongitude = toRadians(destination.longitude - origin.longitude)
  const originLatitude = toRadians(origin.latitude)
  const destinationLatitude = toRadians(destination.latitude)

  const a =
    Math.sin(deltaLatitude / 2) * Math.sin(deltaLatitude / 2)
    + Math.cos(originLatitude)
      * Math.cos(destinationLatitude)
      * Math.sin(deltaLongitude / 2)
      * Math.sin(deltaLongitude / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return earthRadiusMeters * c
}

export function asNullableNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null
  const numeric = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(numeric) ? numeric : null
}
